/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppWWorkspaceIdRouteRouteImport } from './routes/_app/w/$workspaceId/route'
import { Route as AppWWorkspaceIdIndexRouteImport } from './routes/_app/w/$workspaceId/index'
import { Route as AppWWorkspaceIdAnalyticsIndexRouteImport } from './routes/_app/w/$workspaceId/analytics/index'
import { Route as AppWWorkspaceIdAnalyticsNewRouteImport } from './routes/_app/w/$workspaceId/analytics/new'
import { Route as AppWWorkspaceIdAuditsIndexRouteImport } from './routes/_app/w/$workspaceId/audits/index'
import { Route as AppWWorkspaceIdAuditsNewRouteImport } from './routes/_app/w/$workspaceId/audits/new'
import { Route as AppWWorkspaceIdFindingsIndexRouteImport } from './routes/_app/w/$workspaceId/findings/index'
import { Route as AppWWorkspaceIdFindingsFindingIdRouteImport } from './routes/_app/w/$workspaceId/findings/$findingId'
import { Route as AppWWorkspaceIdSettingsIndexRouteImport } from './routes/_app/w/$workspaceId/settings/index'
import { Route as AppWWorkspaceIdSetupIndexRouteImport } from './routes/_app/w/$workspaceId/setup/index'
import { Route as AppWWorkspaceIdTemplatesIndexRouteImport } from './routes/_app/w/$workspaceId/templates/index'
import { Route as AppWWorkspaceIdTemplatesTemplateIdRouteImport } from './routes/_app/w/$workspaceId/templates/$templateId'
import { Route as AppWWorkspaceIdAnalyticsPageIdIndexRouteImport } from './routes/_app/w/$workspaceId/analytics/$pageId/index'
import { Route as AppWWorkspaceIdAnalyticsPageIdEditRouteImport } from './routes/_app/w/$workspaceId/analytics/$pageId/edit'
import { Route as AppWWorkspaceIdAnalyticsReportsReportKeyRouteImport } from './routes/_app/w/$workspaceId/analytics/reports/$reportKey'
import { Route as AppWWorkspaceIdAuditsAuditIdIndexRouteImport } from './routes/_app/w/$workspaceId/audits/$auditId/index'
import { Route as AppWWorkspaceIdAuditsAuditIdEditRouteImport } from './routes/_app/w/$workspaceId/audits/$auditId/edit'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWWorkspaceIdRouteRoute = AppWWorkspaceIdRouteRouteImport.update({
  id: '/w/$workspaceId',
  path: '/w/$workspaceId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWWorkspaceIdIndexRoute = AppWWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWWorkspaceIdRouteRoute,
} as any)
const AppWWorkspaceIdAnalyticsIndexRoute =
  AppWWorkspaceIdAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAnalyticsNewRoute =
  AppWWorkspaceIdAnalyticsNewRouteImport.update({
    id: '/analytics/new',
    path: '/analytics/new',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAuditsIndexRoute =
  AppWWorkspaceIdAuditsIndexRouteImport.update({
    id: '/audits/',
    path: '/audits/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAuditsNewRoute =
  AppWWorkspaceIdAuditsNewRouteImport.update({
    id: '/audits/new',
    path: '/audits/new',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdFindingsIndexRoute =
  AppWWorkspaceIdFindingsIndexRouteImport.update({
    id: '/findings/',
    path: '/findings/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdFindingsFindingIdRoute =
  AppWWorkspaceIdFindingsFindingIdRouteImport.update({
    id: '/findings/$findingId',
    path: '/findings/$findingId',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdSettingsIndexRoute =
  AppWWorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdSetupIndexRoute =
  AppWWorkspaceIdSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdTemplatesIndexRoute =
  AppWWorkspaceIdTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdTemplatesTemplateIdRoute =
  AppWWorkspaceIdTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAnalyticsPageIdIndexRoute =
  AppWWorkspaceIdAnalyticsPageIdIndexRouteImport.update({
    id: '/analytics/$pageId/',
    path: '/analytics/$pageId/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAnalyticsPageIdEditRoute =
  AppWWorkspaceIdAnalyticsPageIdEditRouteImport.update({
    id: '/analytics/$pageId/edit',
    path: '/analytics/$pageId/edit',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAnalyticsReportsReportKeyRoute =
  AppWWorkspaceIdAnalyticsReportsReportKeyRouteImport.update({
    id: '/analytics/reports/$reportKey',
    path: '/analytics/reports/$reportKey',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAuditsAuditIdIndexRoute =
  AppWWorkspaceIdAuditsAuditIdIndexRouteImport.update({
    id: '/audits/$auditId/',
    path: '/audits/$auditId/',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)
const AppWWorkspaceIdAuditsAuditIdEditRoute =
  AppWWorkspaceIdAuditsAuditIdEditRouteImport.update({
    id: '/audits/$auditId/edit',
    path: '/audits/$auditId/edit',
    getParentRoute: () => AppWWorkspaceIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/signed-out': typeof SignedOutRoute
  '/w/$workspaceId': typeof AppWWorkspaceIdRouteRouteWithChildren
  '/w/$workspaceId/': typeof AppWWorkspaceIdIndexRoute
  '/w/$workspaceId/analytics/new': typeof AppWWorkspaceIdAnalyticsNewRoute
  '/w/$workspaceId/audits/new': typeof AppWWorkspaceIdAuditsNewRoute
  '/w/$workspaceId/findings/$findingId': typeof AppWWorkspaceIdFindingsFindingIdRoute
  '/w/$workspaceId/templates/$templateId': typeof AppWWorkspaceIdTemplatesTemplateIdRoute
  '/w/$workspaceId/analytics/': typeof AppWWorkspaceIdAnalyticsIndexRoute
  '/w/$workspaceId/audits/': typeof AppWWorkspaceIdAuditsIndexRoute
  '/w/$workspaceId/findings/': typeof AppWWorkspaceIdFindingsIndexRoute
  '/w/$workspaceId/settings/': typeof AppWWorkspaceIdSettingsIndexRoute
  '/w/$workspaceId/setup/': typeof AppWWorkspaceIdSetupIndexRoute
  '/w/$workspaceId/templates/': typeof AppWWorkspaceIdTemplatesIndexRoute
  '/w/$workspaceId/analytics/$pageId/edit': typeof AppWWorkspaceIdAnalyticsPageIdEditRoute
  '/w/$workspaceId/analytics/reports/$reportKey': typeof AppWWorkspaceIdAnalyticsReportsReportKeyRoute
  '/w/$workspaceId/audits/$auditId/edit': typeof AppWWorkspaceIdAuditsAuditIdEditRoute
  '/w/$workspaceId/analytics/$pageId/': typeof AppWWorkspaceIdAnalyticsPageIdIndexRoute
  '/w/$workspaceId/audits/$auditId/': typeof AppWWorkspaceIdAuditsAuditIdIndexRoute
}
export interface FileRoutesByTo {
  '/signed-out': typeof SignedOutRoute
  '/': typeof AppIndexRoute
  '/w/$workspaceId': typeof AppWWorkspaceIdIndexRoute
  '/w/$workspaceId/analytics/new': typeof AppWWorkspaceIdAnalyticsNewRoute
  '/w/$workspaceId/audits/new': typeof AppWWorkspaceIdAuditsNewRoute
  '/w/$workspaceId/findings/$findingId': typeof AppWWorkspaceIdFindingsFindingIdRoute
  '/w/$workspaceId/templates/$templateId': typeof AppWWorkspaceIdTemplatesTemplateIdRoute
  '/w/$workspaceId/analytics': typeof AppWWorkspaceIdAnalyticsIndexRoute
  '/w/$workspaceId/audits': typeof AppWWorkspaceIdAuditsIndexRoute
  '/w/$workspaceId/findings': typeof AppWWorkspaceIdFindingsIndexRoute
  '/w/$workspaceId/settings': typeof AppWWorkspaceIdSettingsIndexRoute
  '/w/$workspaceId/setup': typeof AppWWorkspaceIdSetupIndexRoute
  '/w/$workspaceId/templates': typeof AppWWorkspaceIdTemplatesIndexRoute
  '/w/$workspaceId/analytics/$pageId/edit': typeof AppWWorkspaceIdAnalyticsPageIdEditRoute
  '/w/$workspaceId/analytics/reports/$reportKey': typeof AppWWorkspaceIdAnalyticsReportsReportKeyRoute
  '/w/$workspaceId/audits/$auditId/edit': typeof AppWWorkspaceIdAuditsAuditIdEditRoute
  '/w/$workspaceId/analytics/$pageId': typeof AppWWorkspaceIdAnalyticsPageIdIndexRoute
  '/w/$workspaceId/audits/$auditId': typeof AppWWorkspaceIdAuditsAuditIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/_app/': typeof AppIndexRoute
  '/_app/w/$workspaceId': typeof AppWWorkspaceIdRouteRouteWithChildren
  '/_app/w/$workspaceId/': typeof AppWWorkspaceIdIndexRoute
  '/_app/w/$workspaceId/analytics/new': typeof AppWWorkspaceIdAnalyticsNewRoute
  '/_app/w/$workspaceId/audits/new': typeof AppWWorkspaceIdAuditsNewRoute
  '/_app/w/$workspaceId/findings/$findingId': typeof AppWWorkspaceIdFindingsFindingIdRoute
  '/_app/w/$workspaceId/templates/$templateId': typeof AppWWorkspaceIdTemplatesTemplateIdRoute
  '/_app/w/$workspaceId/analytics/': typeof AppWWorkspaceIdAnalyticsIndexRoute
  '/_app/w/$workspaceId/audits/': typeof AppWWorkspaceIdAuditsIndexRoute
  '/_app/w/$workspaceId/findings/': typeof AppWWorkspaceIdFindingsIndexRoute
  '/_app/w/$workspaceId/settings/': typeof AppWWorkspaceIdSettingsIndexRoute
  '/_app/w/$workspaceId/setup/': typeof AppWWorkspaceIdSetupIndexRoute
  '/_app/w/$workspaceId/templates/': typeof AppWWorkspaceIdTemplatesIndexRoute
  '/_app/w/$workspaceId/analytics/$pageId/edit': typeof AppWWorkspaceIdAnalyticsPageIdEditRoute
  '/_app/w/$workspaceId/analytics/reports/$reportKey': typeof AppWWorkspaceIdAnalyticsReportsReportKeyRoute
  '/_app/w/$workspaceId/audits/$auditId/edit': typeof AppWWorkspaceIdAuditsAuditIdEditRoute
  '/_app/w/$workspaceId/analytics/$pageId/': typeof AppWWorkspaceIdAnalyticsPageIdIndexRoute
  '/_app/w/$workspaceId/audits/$auditId/': typeof AppWWorkspaceIdAuditsAuditIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signed-out'
    | '/w/$workspaceId'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/analytics/new'
    | '/w/$workspaceId/audits/new'
    | '/w/$workspaceId/findings/$findingId'
    | '/w/$workspaceId/templates/$templateId'
    | '/w/$workspaceId/analytics/'
    | '/w/$workspaceId/audits/'
    | '/w/$workspaceId/findings/'
    | '/w/$workspaceId/settings/'
    | '/w/$workspaceId/setup/'
    | '/w/$workspaceId/templates/'
    | '/w/$workspaceId/analytics/$pageId/edit'
    | '/w/$workspaceId/analytics/reports/$reportKey'
    | '/w/$workspaceId/audits/$auditId/edit'
    | '/w/$workspaceId/analytics/$pageId/'
    | '/w/$workspaceId/audits/$auditId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signed-out'
    | '/'
    | '/w/$workspaceId'
    | '/w/$workspaceId/analytics/new'
    | '/w/$workspaceId/audits/new'
    | '/w/$workspaceId/findings/$findingId'
    | '/w/$workspaceId/templates/$templateId'
    | '/w/$workspaceId/analytics'
    | '/w/$workspaceId/audits'
    | '/w/$workspaceId/findings'
    | '/w/$workspaceId/settings'
    | '/w/$workspaceId/setup'
    | '/w/$workspaceId/templates'
    | '/w/$workspaceId/analytics/$pageId/edit'
    | '/w/$workspaceId/analytics/reports/$reportKey'
    | '/w/$workspaceId/audits/$auditId/edit'
    | '/w/$workspaceId/analytics/$pageId'
    | '/w/$workspaceId/audits/$auditId'
  id:
    | '__root__'
    | '/_app'
    | '/signed-out'
    | '/_app/'
    | '/_app/w/$workspaceId'
    | '/_app/w/$workspaceId/'
    | '/_app/w/$workspaceId/analytics/new'
    | '/_app/w/$workspaceId/audits/new'
    | '/_app/w/$workspaceId/findings/$findingId'
    | '/_app/w/$workspaceId/templates/$templateId'
    | '/_app/w/$workspaceId/analytics/'
    | '/_app/w/$workspaceId/audits/'
    | '/_app/w/$workspaceId/findings/'
    | '/_app/w/$workspaceId/settings/'
    | '/_app/w/$workspaceId/setup/'
    | '/_app/w/$workspaceId/templates/'
    | '/_app/w/$workspaceId/analytics/$pageId/edit'
    | '/_app/w/$workspaceId/analytics/reports/$reportKey'
    | '/_app/w/$workspaceId/audits/$auditId/edit'
    | '/_app/w/$workspaceId/analytics/$pageId/'
    | '/_app/w/$workspaceId/audits/$auditId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/w/$workspaceId': {
      id: '/_app/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/w/$workspaceId'
      preLoaderRoute: typeof AppWWorkspaceIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/w/$workspaceId/': {
      id: '/_app/w/$workspaceId/'
      path: '/'
      fullPath: '/w/$workspaceId/'
      preLoaderRoute: typeof AppWWorkspaceIdIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/analytics/': {
      id: '/_app/w/$workspaceId/analytics/'
      path: '/analytics'
      fullPath: '/w/$workspaceId/analytics/'
      preLoaderRoute: typeof AppWWorkspaceIdAnalyticsIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/analytics/new': {
      id: '/_app/w/$workspaceId/analytics/new'
      path: '/analytics/new'
      fullPath: '/w/$workspaceId/analytics/new'
      preLoaderRoute: typeof AppWWorkspaceIdAnalyticsNewRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/audits/': {
      id: '/_app/w/$workspaceId/audits/'
      path: '/audits'
      fullPath: '/w/$workspaceId/audits/'
      preLoaderRoute: typeof AppWWorkspaceIdAuditsIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/audits/new': {
      id: '/_app/w/$workspaceId/audits/new'
      path: '/audits/new'
      fullPath: '/w/$workspaceId/audits/new'
      preLoaderRoute: typeof AppWWorkspaceIdAuditsNewRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/findings/': {
      id: '/_app/w/$workspaceId/findings/'
      path: '/findings'
      fullPath: '/w/$workspaceId/findings/'
      preLoaderRoute: typeof AppWWorkspaceIdFindingsIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/findings/$findingId': {
      id: '/_app/w/$workspaceId/findings/$findingId'
      path: '/findings/$findingId'
      fullPath: '/w/$workspaceId/findings/$findingId'
      preLoaderRoute: typeof AppWWorkspaceIdFindingsFindingIdRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/settings/': {
      id: '/_app/w/$workspaceId/settings/'
      path: '/settings'
      fullPath: '/w/$workspaceId/settings/'
      preLoaderRoute: typeof AppWWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/setup/': {
      id: '/_app/w/$workspaceId/setup/'
      path: '/setup'
      fullPath: '/w/$workspaceId/setup/'
      preLoaderRoute: typeof AppWWorkspaceIdSetupIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/templates/': {
      id: '/_app/w/$workspaceId/templates/'
      path: '/templates'
      fullPath: '/w/$workspaceId/templates/'
      preLoaderRoute: typeof AppWWorkspaceIdTemplatesIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/templates/$templateId': {
      id: '/_app/w/$workspaceId/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/w/$workspaceId/templates/$templateId'
      preLoaderRoute: typeof AppWWorkspaceIdTemplatesTemplateIdRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/analytics/$pageId/': {
      id: '/_app/w/$workspaceId/analytics/$pageId/'
      path: '/analytics/$pageId'
      fullPath: '/w/$workspaceId/analytics/$pageId/'
      preLoaderRoute: typeof AppWWorkspaceIdAnalyticsPageIdIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/analytics/$pageId/edit': {
      id: '/_app/w/$workspaceId/analytics/$pageId/edit'
      path: '/analytics/$pageId/edit'
      fullPath: '/w/$workspaceId/analytics/$pageId/edit'
      preLoaderRoute: typeof AppWWorkspaceIdAnalyticsPageIdEditRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/analytics/reports/$reportKey': {
      id: '/_app/w/$workspaceId/analytics/reports/$reportKey'
      path: '/analytics/reports/$reportKey'
      fullPath: '/w/$workspaceId/analytics/reports/$reportKey'
      preLoaderRoute: typeof AppWWorkspaceIdAnalyticsReportsReportKeyRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/audits/$auditId/': {
      id: '/_app/w/$workspaceId/audits/$auditId/'
      path: '/audits/$auditId'
      fullPath: '/w/$workspaceId/audits/$auditId/'
      preLoaderRoute: typeof AppWWorkspaceIdAuditsAuditIdIndexRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
    '/_app/w/$workspaceId/audits/$auditId/edit': {
      id: '/_app/w/$workspaceId/audits/$auditId/edit'
      path: '/audits/$auditId/edit'
      fullPath: '/w/$workspaceId/audits/$auditId/edit'
      preLoaderRoute: typeof AppWWorkspaceIdAuditsAuditIdEditRouteImport
      parentRoute: typeof AppWWorkspaceIdRouteRoute
    }
  }
}

interface AppWWorkspaceIdRouteRouteChildren {
  AppWWorkspaceIdIndexRoute: typeof AppWWorkspaceIdIndexRoute
  AppWWorkspaceIdAnalyticsNewRoute: typeof AppWWorkspaceIdAnalyticsNewRoute
  AppWWorkspaceIdAuditsNewRoute: typeof AppWWorkspaceIdAuditsNewRoute
  AppWWorkspaceIdFindingsFindingIdRoute: typeof AppWWorkspaceIdFindingsFindingIdRoute
  AppWWorkspaceIdTemplatesTemplateIdRoute: typeof AppWWorkspaceIdTemplatesTemplateIdRoute
  AppWWorkspaceIdAnalyticsIndexRoute: typeof AppWWorkspaceIdAnalyticsIndexRoute
  AppWWorkspaceIdAuditsIndexRoute: typeof AppWWorkspaceIdAuditsIndexRoute
  AppWWorkspaceIdFindingsIndexRoute: typeof AppWWorkspaceIdFindingsIndexRoute
  AppWWorkspaceIdSettingsIndexRoute: typeof AppWWorkspaceIdSettingsIndexRoute
  AppWWorkspaceIdSetupIndexRoute: typeof AppWWorkspaceIdSetupIndexRoute
  AppWWorkspaceIdTemplatesIndexRoute: typeof AppWWorkspaceIdTemplatesIndexRoute
  AppWWorkspaceIdAnalyticsPageIdEditRoute: typeof AppWWorkspaceIdAnalyticsPageIdEditRoute
  AppWWorkspaceIdAnalyticsReportsReportKeyRoute: typeof AppWWorkspaceIdAnalyticsReportsReportKeyRoute
  AppWWorkspaceIdAuditsAuditIdEditRoute: typeof AppWWorkspaceIdAuditsAuditIdEditRoute
  AppWWorkspaceIdAnalyticsPageIdIndexRoute: typeof AppWWorkspaceIdAnalyticsPageIdIndexRoute
  AppWWorkspaceIdAuditsAuditIdIndexRoute: typeof AppWWorkspaceIdAuditsAuditIdIndexRoute
}

const AppWWorkspaceIdRouteRouteChildren: AppWWorkspaceIdRouteRouteChildren = {
  AppWWorkspaceIdIndexRoute: AppWWorkspaceIdIndexRoute,
  AppWWorkspaceIdAnalyticsNewRoute: AppWWorkspaceIdAnalyticsNewRoute,
  AppWWorkspaceIdAuditsNewRoute: AppWWorkspaceIdAuditsNewRoute,
  AppWWorkspaceIdFindingsFindingIdRoute: AppWWorkspaceIdFindingsFindingIdRoute,
  AppWWorkspaceIdTemplatesTemplateIdRoute:
    AppWWorkspaceIdTemplatesTemplateIdRoute,
  AppWWorkspaceIdAnalyticsIndexRoute: AppWWorkspaceIdAnalyticsIndexRoute,
  AppWWorkspaceIdAuditsIndexRoute: AppWWorkspaceIdAuditsIndexRoute,
  AppWWorkspaceIdFindingsIndexRoute: AppWWorkspaceIdFindingsIndexRoute,
  AppWWorkspaceIdSettingsIndexRoute: AppWWorkspaceIdSettingsIndexRoute,
  AppWWorkspaceIdSetupIndexRoute: AppWWorkspaceIdSetupIndexRoute,
  AppWWorkspaceIdTemplatesIndexRoute: AppWWorkspaceIdTemplatesIndexRoute,
  AppWWorkspaceIdAnalyticsPageIdEditRoute:
    AppWWorkspaceIdAnalyticsPageIdEditRoute,
  AppWWorkspaceIdAnalyticsReportsReportKeyRoute:
    AppWWorkspaceIdAnalyticsReportsReportKeyRoute,
  AppWWorkspaceIdAuditsAuditIdEditRoute: AppWWorkspaceIdAuditsAuditIdEditRoute,
  AppWWorkspaceIdAnalyticsPageIdIndexRoute:
    AppWWorkspaceIdAnalyticsPageIdIndexRoute,
  AppWWorkspaceIdAuditsAuditIdIndexRoute:
    AppWWorkspaceIdAuditsAuditIdIndexRoute,
}

const AppWWorkspaceIdRouteRouteWithChildren =
  AppWWorkspaceIdRouteRoute._addFileChildren(AppWWorkspaceIdRouteRouteChildren)

interface AppRouteRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppWWorkspaceIdRouteRoute: typeof AppWWorkspaceIdRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppWWorkspaceIdRouteRoute: AppWWorkspaceIdRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
